<template>
  <nuttrema-layout-content
    centralClassName="is-white">
    <nuttrema-layout-content-header slot="header" class="is-slim">
      <div class="content-header-item w-100" slot="left">
        <nuttrema-group-and-sort
          class="is-horizontal w-100">
          <h4 slot="label">{{ $t('label.graph_type') }}</h4>
          <el-select
             slot="content"
             v-model="activeChart"
             class="w-100"
             size="small"
             placeholder="$t('graph_type')">
            <el-option-group
               v-for="section in sections"
              :key="section.code"
              :label="$t(section.name)">
              <el-option
                 v-for="chart in section.charts"
                :key="chart.code"
                :label="`${$t(section.name)}: (${$t(chart.name)})`"
                :value="chart.code">
                <!-- :disabled="!trackable[section.code].charts[chart.code].trackable"> -->
                <span>{{ $t(chart.name) }}</span>
              </el-option>
            </el-option-group>
          </el-select>
        </nuttrema-group-and-sort>
      </div>
      <div class="content-header-item" slot="right">
        <el-popover
           ref="graph-type-note"
           placement="top-start"
           width="250"
           trigger="click"
           popper-class="el-popover--status"
          :title="$t('label.note')"
          :content="$t('label.available_graph_depends')">
        </el-popover>
        <el-button type="text" size="mini" v-popover:graph-type-note>
          <i class="fas fa-exclamation-circle"></i> {{ $t('label.note') }}
        </el-button>
      </div>
    </nuttrema-layout-content-header>
    <measurements-graph
       slot="central"
      :activeChart="activeChart"
      :chartDetails="chartDetails"
      :measurementDetails="measurementDetails"
      :trackable="trackable"
      :state="PersonMeasurements">
    </measurements-graph>
  </nuttrema-layout-content>
</template>

<script>
import { each, has, get, isEmpty } from 'lodash';
import * as calendar from 'utils/calendar';

import NuttremaLayoutContent from 'components/ui/layout/nuttrema-layout-content';
import NuttremaLayoutContentHeader from 'components/ui/layout/nuttrema-layout-content-header';
import NuttremaGroupAndSort from 'components/ui/panels/nuttrema-panel-group-and-sort';

import MeasurementsGraph from './cmpt-measurements-graph';

export default {
  name: 'page-evolution-measurements-graph',
  props: {
    id: {
      required: true,
      default: null,
    },
    meta: {
      required: true,
      default: null,
    },
    period: {
      type: String,
      required: false,
      default: null,
    },
    dateFrom: {
      type: String,
      required: false,
      default: null,
    },
    dateTo: {
      type: String,
      required: false,
      default: null,
    },
  },
  components: {
    NuttremaLayoutContent,
    NuttremaLayoutContentHeader,
    NuttremaGroupAndSort,
    MeasurementsGraph,
  },
  data() {
    return {
      sections: [
        {
          code: 'body_composition',
          name: 'label.body_composition',
          charts: [
            {
              name: 'label.components_with_bmi',
              code: 'chart-body-components',
              required: [
                {
                  group: 'body_mass_index',
                  measurements: [
                    {
                      type: 'derived',
                      code: 'body_mass_index',
                    },
                    {
                      type: 'derived',
                      code: 'body_mass_index_category',
                    },
                  ],
                },
                {
                  group: 'body_composition',
                  measurements: [
                    {
                      type: 'primitive',
                      code: 'weight',
                    },
                    {
                      type: 'derived',
                      code: 'body_water_weight',
                    },
                    {
                      type: 'derived',
                      code: 'body_fat_weight',
                    },
                    {
                      type: 'derived',
                      code: 'optimal_fat_weight',
                    },
                  ],
                },
              ],
            },
            {
              name: 'label.weight_structure',
              code: 'chart-weight-structure',
              required: [
                {
                  group: 'body_mass_index',
                  measurements: [
                    {
                      type: 'derived',
                      code: 'body_mass_index',
                    },
                    {
                      type: 'derived',
                      code: 'body_mass_index_category',
                    },
                  ],
                },
                {
                  group: 'body_composition',
                  measurements: [
                    {
                      type: 'primitive',
                      code: 'weight',
                    },
                    {
                      type: 'derived',
                      code: 'body_water_weight',
                    },
                    {
                      type: 'derived',
                      code: 'body_fat_weight',
                    },
                    {
                      type: 'derived',
                      code: 'optimal_fat_weight',
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          code: 'metabolic_rates',
          name: 'label.metabolic_rates',
          charts: [
            {
              name: 'label.metabolic_rates',
              code: 'chart-metabolic-rates',
              required: [
                {
                  group: 'metabolic_rates',
                  measurements: [
                    {
                      type: 'derived',
                      code: 'basal_metabolic_rate',
                    },
                    {
                      type: 'derived',
                      code: 'resting_metabolic_rate',
                    },
                    {
                      type: 'derived',
                      code: 'der_bmr_based',
                    },
                    {
                      type: 'derived',
                      code: 'der_rmr_based',
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          code: 'morphometrics',
          name: 'label.morphometrics',
          charts: [
            {
              name: 'label.waist_hip_ratio',
              code: 'chart-morphometrics-waist-hip-ratio',
              required: [],
            },
          ],
        },
        {
          code: 'body_vitals',
          name: 'label.body_vitals',
          charts: [
            {
              name: 'label.heart_and_respiratory_rates',
              code: 'chart-body-vitals-heart-respiratory-rates',
              required: [],
            },
            {
              name: 'label.blood_pressure_and_glucose',
              code: 'chart-body-vitals-blood-pressure-glucose',
              required: [],
            },
            {
              name: 'label.body_temperature',
              code: 'chart-body-vitals-body-temperature',
              required: [],
            },
          ],
        },
      ],
      activeChart: 'chart-body-components',
    };
  },
  methods: {
    chartTrackedMeasurements(chart) {
      const measurementsTracked = [];
      if (!isEmpty(chart.required)) {
        each(chart.required, (required) => {
          each(required.measurements, (measurement) => {
            const measurementTracked = get(this.PersonSettingsTrackedMeasurements, `data.${required.group}.MeasurementTypes.${measurement.type}.${measurement.code}.tracked`);
            if (measurementTracked) measurementsTracked.push(measurement.code);
          });
        });
      }
      return measurementsTracked;
    },
    sectionHasTracked(sectionCode) {
      return has(this.PersonSettingsTrackedMeasurements, `data.${sectionCode}.has_tracked`) ? this.PersonSettingsTrackedMeasurements.data[sectionCode].has_tracked : false;
    },
  },
  computed: {
    PersonDetails() {
      return this.$store.getters.PersonDetails(this.id);
    },
    PersonMeasurements() {
      return this.$store.getters.PersonMeasurements(this.id);
    },
    PersonSettingsTrackedMeasurements() {
      return this.$store.getters.PersonSettingsTrackedMeasurements(this.id);
    },
    trackable() {
      const trackable = {};
      // each(this.sections, (section) => {
      //   const sectionTracked = this.sectionHasTracked(section.code);
      //   Vue.set(trackable, section.code, { trackable: sectionTracked, charts: {} });
      //   each(section.charts, (chart) => {
      //     const trackedMeasurements = this.chartTrackedMeasurements(chart);
      //     const chartTrackable = trackedMeasurements.length > 0;
      //     Vue.set(trackable[section.code].charts, chart.code, {
      //       trackable: chartTrackable,
      //       trackedMeasurements,
      //     });
      //   });
      // });
      return trackable;
    },
    chartDetails() {
      let details = null;
      each(this.sections, (section) => {
        each(section.charts, (chart) => {
          if (chart.code === this.activeChart) {
            details = {
              section: section.name,
              chart: chart.name,
            };
            return false;
          }
          return true;
        });
      });
      return details;
    },
    measurementDetails() {
      const date = calendar.getPeriod(this.period, this.dateFrom, this.dateTo);
      const participant = get(this.PersonDetails, 'data.full_name');
      return {
        participant,
        date,
      };
    },
  },
  created() {
    console.log('page-evolution-measurements-graph created');
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/participants/participant-evolution/dashboard/page-evolution-measurements-graph.vue